let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lWAHs")).then(() => parcelRequire('fl1JA'));